export class CartGroupValueItem {
  value!: number;
  nameKey?: string;
  label?: string;

  constructor(item: { value: number; nameKey?: string; label?: string }) {
    this.value = item.value;
    if (item.nameKey) {
      this.nameKey = item.nameKey;
    }
    if (item.label) {
      this.label = item.label;
    }
  }
}
